var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftBorderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 0.00390625H10C11.1046 0.00390625 12 0.899336 12 2.00391V10.0017C12 11.1063 11.1046 12.0017 10 12.0017H3V9.92755H9C9.55228 9.92755 10 9.47983 10 8.92755V2.88608C10 2.33379 9.55228 1.88608 9 1.88608H3V0.00390625Z",
    fill: "#D8D8D8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895431 0.895431 0 2 0V12C0.895431 12 0 11.1046 0 10V2Z",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftBorderIcon);
export default __webpack_public_path__ + "static/media/left-border-icon.11001034036cd344a27b94383bab9011.svg";
export { ForwardRef as ReactComponent };